<template>
  <div>
    <breadcrumb/>
    <post-list category="Factoring-Conoce como se hace-Capacitaciones sobre Nuestros sistemas"></post-list>
  </div>
</template>

<script>
import PostList from "@/components/Posts/PostList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    PostList,
    Breadcrumb
  }
};
</script>
